<!-- PREVIOUS GROID -->

<div>
    <ul class="rv-sidebar">
        <ng-container *ngFor="let itone of filtermenus(0)">
            <li [class.rv-sub-menu]="childitemcount(itone.menuid) >= 1" class="rv-menu-item">
                <a (click)="selectOnlyThis(itone.menuid,itone.parentmenuid)" *ngIf="itone.routelink != ''" routerLink="{{ itone.routelink }}" routerLinkActive="active-submenu">
                    <i class="{{itone.css}}"></i><span class="menu-title">{{ itone.menuname }}</span>
                </a>

                <input *ngIf="itone.routelink == ''" type="checkbox" id="check{{ itone.menuid }}" (click)="selectOnlyThis(itone.menuid,itone.parentmenuid)" />
                <label *ngIf="itone.routelink == ''" for="check{{ itone.menuid }}"><i class="{{itone.css}}"></i> <span>{{ itone.menuname }}</span></label>

                <!-- SUB ITEM 2 -->
                <div *ngIf="childitemcount(itone.menuid) >= 1" class="rv-sub-list second-menu">
                    <ul>
                        <li *ngFor="let ittwo of filtermenus(itone.menuid)" [class.rv-sub-menu]="childitemcount(ittwo.menuid) >= 1" class="rv-menu-item">
                             <a *ngIf="ittwo.routelink != ''" routerLink="{{ ittwo.routelink }}" routerLinkActive="active-submenu">
                                <span class="menu-title">{{ ittwo.menuname }}</span>
                            </a>

                            <input *ngIf="ittwo.routelink == ''" type="checkbox" id="check{{ ittwo.menuid }}" (click)="selectOnlyThis(ittwo.menuid,ittwo.parentmenuid)" />
                            <label *ngIf="ittwo.routelink == ''" for="check{{ ittwo.menuid }}"><i class="{{ittwo.css}}"></i><span>{{ ittwo.menuname }}</span></label>

                            <!-- SUB ITEM 3 -->
                            <div *ngIf="childitemcount(ittwo.menuid) >= 1" class="rv-sub-list second-menu">
                                <ul class="">
                                    <li *ngFor="let itthree of filtermenus(ittwo.menuid)" [class.rv-sub-menu]="childitemcount(itthree.menuid) >= 1" class="rv-menu-item">
                                        <a *ngIf="itthree.routelink != ''" routerLink="{{ itthree.routelink }}" routerLinkActive="active-submenu">
                                            <span class="menu-title">{{ itthree.menuname }}</span>
                                        </a>

                                        <input *ngIf="itthree.routelink == ''" type="checkbox" id="check{{ itthree.menuid }}" (click)="selectOnlyThis(itthree.menuid,itthree.parentmenuid)" />
                                        <label *ngIf="itthree.routelink == ''" for="check{{ itthree.menuid }}"><span>{{ itthree.menuname
                      }}</span></label>
                                    </li>
                                </ul>
                            </div>
                            <!-- SUB ITEM 3 END-->
                            
                        </li>
                    </ul>
                </div>
                <!-- SUB ITEM 2 END-->
                
            </li>
        </ng-container>
    </ul>
</div>

